import Container from "../../../components/element/container";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import OrderDocumentsModal from "../../../components/modal/order.documents.modal";
import OrderReceiptsModal from "../../../components/modal/order.receipts.modal";

import { hasOrderReceipts } from "../../../helpers/order.receipts";
import Button from "../../../components/element/button";
import Col from "../../../components/element/col";
import Icon from "../../../components/element/icon";
import useWindowDimension from "../../../components/hook/use.window.dimension";

export default function PurchaseRecord({
  purchase,
  onPay,
  active = false,
  onToggle,
  canViewDetails = true,
}) {
  const [documentsOpen, setDocumentsOpen] = useState(false);
  const [receiptsOpen, setReceiptsOpen] = useState(false);
  const { t } = useTranslation();
  const { width } = useWindowDimension();



  // Tapping the card opens its steps, but the buttons and links inside it keep
  // their own behaviour.
  const handleCardClick = (event) => {
    if (!canViewDetails || !onToggle || event.target.closest("button, a")) {
      return;
    }
    onToggle();
  };

  const statusClass = purchase.status.toLowerCase().replace(/\s+/g, "-");
  const details = [
    ["Reservation ID", purchase.reservationId, "accent"],
    ["Reservation On", purchase.reservationDate],
    width > 991 && ["status", purchase.status, "status"],
    ["Selling Price", purchase.sellingPrice],
    ["Conditioning Cost", purchase.conditioningCost],
    ["Warranty Cost", purchase.warrantyCost],
    width < 991 && ["status", purchase.status, "status"],
  ].filter(Boolean);

  return (
    <>
      <article
        className={`purchase-record ${statusClass} ${active ? "is-active" : ""}`}
        onClick={handleCardClick}
      >
        <Container tag="div" className="purchase-record-media">
          <img
            className={purchase.hasImage ? "" : "default"}
            src={purchase.image}
            alt={purchase.name}
          />
        </Container>
        <Container tag="div" className="purchase-record-content">
          <header
            className={`purchase-record-header ${width < 650 && purchase?.paymentStatus === "pending" ? "flex-col" : ""}`}
          >
            <h2>{purchase.name || ""}</h2>
            <Container tag="div"
              className={`purchase-record-icons ${width < 650 && purchase?.paymentStatus === "pending" ? "w-100 justify-end" : ""}`}
            >
              {/* {hasDocuments && (
                <button
                  type="button"
                  className="record-icon-button"
                  aria-label="View vehicle documents"
                  onClick={() => setDocumentsOpen(true)}
                >
                  <Icon
                    icon="fluent:document-one-page-link-24-regular"
                    className="--doc"
                  />
                </button>
              )} */}
              {hasOrderReceipts(purchase) && (
                <button
                  type="button"
                  className="record-icon-button"
                  aria-label="View official receipts"
                  onClick={() => setReceiptsOpen(true)}
                >
                  <Icon icon="solar:bill-list-linear" className="--doc" />
                </button>
              )}
              {/* {onToggle && (
                <button
                  type="button"
                  className="record-icon-button record-expand-toggle"
                  aria-expanded={active}
                  aria-label={active ? "Hide purchase steps" : "Show purchase steps"}
                  onClick={onToggle}
                >
                  <Icon
                    icon="solar:alt-arrow-down-linear"
                    className={active ? "is-open" : ""}
                  />
                </button>
              )} */}
              {purchase.productId && (
                <Link
                  className="record-icon-button"
                  to={`/car/${purchase.productId}`}
                  aria-label="View car information"
                >
                  <Icon icon="mdi:car-info" />
                </Link>
              )}
              {purchase?.paymentStatus === "pending" && (
                <Button type="button" onClick={() => onPay(purchase)}>
                  <Icon icon="solar:card-linear" />
                  {t("Pay")}
                </Button>
              )}
            </Container>
          </header>
          <Col className="_col purchase-divider" />
          <Container tag="div" className="purchase-record-details-row">
            <Container tag="div" className="purchase-record-details">
              {details.map(([label, value, variant]) =>
                label === "status" ? (
                  <p className={`purchase-status ${statusClass}`} key={label}>
                    {t(value)}
                  </p>
                ) : (
                  <dl className={variant || ""} key={label}>
                    <dt>{t(label)}</dt>
                    <dd>{value}</dd>
                  </dl>
                ),
              )}
            </Container>
            {canViewDetails && onToggle && (
              <button
                type="button"
                className="purchase-record-details-toggle"
                aria-expanded={active}
                onClick={onToggle}
              >
                {t(active ? "Hide details" : "View details")}
                <Icon
                  icon={
                    active
                      ? "solar:alt-arrow-up-linear"
                      : "solar:alt-arrow-down-linear"
                  }
                />
              </button>
            )}
          </Container>
        </Container>
      </article>
      {documentsOpen && (
        <OrderDocumentsModal
          order={purchase}
          onClose={() => setDocumentsOpen(false)}
        />
      )}
      {receiptsOpen && (
        <OrderReceiptsModal
          order={purchase}
          onClose={() => setReceiptsOpen(false)}
        />
      )}
    </>
  );
}
